import { render, staticRenderFns } from "./FullDataPanel.vue?vue&type=template&id=72c438a6&scoped=true"
import script from "./FullDataPanel.vue?vue&type=script&lang=js"
export * from "./FullDataPanel.vue?vue&type=script&lang=js"
import style0 from "./FullDataPanel.vue?vue&type=style&index=0&id=72c438a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c438a6",
  null
  
)

export default component.exports